import { myLocalStorage } from "../StorageHelper";

type AzureSubscriptionSelection = {
  azureSubscriptionId?: string;
  subscriptionName?: string;
};

const parseMaybeJson = (value: any) => {
  if (typeof value !== "string") return value;
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};

const getAzureSubscription = (): AzureSubscriptionSelection | null => {
  const stored = parseMaybeJson(myLocalStorage.getItem("latestSubList"));
  if (!stored) return null;
  if (typeof stored === "string") {
    return { azureSubscriptionId: stored, subscriptionName: stored };
  }
  return stored;
};

export const getCloudAccountLabel = (cloudProvider: string) => {
  const provider = cloudProvider?.toLowerCase();
  if (provider === "gcp") return "GCP project";
  if (provider === "azure") return "Azure subscription";
  return "AWS account";
};

export const getCloudAccountSelection = (cloudProvider: string) => {
  const provider = cloudProvider?.toLowerCase();
  let id = "";

  if (provider === "gcp") {
    id = myLocalStorage.getItem("gcpSelectedProjectId") || "";
  } else if (provider === "azure") {
    id = getAzureSubscription()?.azureSubscriptionId || "";
  } else if (provider === "aws") {
    id = myLocalStorage.getItem("selectedAwsAccount") || "";
  }

  const label = getCloudAccountLabel(provider);
  const article = label.startsWith("AWS") || label.startsWith("Azure") ? "an" : "a";

  return {
    id,
    configured: Boolean(id),
    label,
    title: `No ${label} configured`,
    description: `Configure ${article} ${label} for this tenant to view ${provider?.toUpperCase()} data.`,
  };
};

export const getCloudAccountDisplayName = (cloudProvider: string, fallback = "") => {
  const provider = cloudProvider?.toLowerCase();
  if (provider === "gcp") {
    return myLocalStorage.getItem("gcpSelectedProjectName") || fallback;
  }
  if (provider === "aws") {
    const account = parseMaybeJson(myLocalStorage.getItem("userDetails"));
    return myLocalStorage.getItem("selectedAwsAccountName") ||
      account?.accountName ||
      account?.awsAccountName ||
      fallback;
  }
  if (provider === "azure") {
    return getAzureSubscription()?.subscriptionName || fallback;
  }
  return fallback;
};

export const clearCloudAccountSelection = (cloudProvider: string) => {
  const provider = cloudProvider?.toLowerCase();
  if (provider === "gcp") {
    myLocalStorage.setItem("gcpSelectedProjectId", "");
    myLocalStorage.setItem("gcpSelectedProjectName", "");
  } else if (provider === "azure") {
    myLocalStorage.setItem(
      "latestSubList",
      JSON.stringify({ azureSubscriptionId: "", subscriptionName: "None" }),
    );
  } else if (provider === "aws") {
    myLocalStorage.setItem("selectedAwsAccount", "");
    myLocalStorage.setItem("selectedAwsAccountName", "");
  }
};

export const selectCloudAccount = (cloudProvider: string, accountId: string) => {
  const provider = cloudProvider?.toLowerCase();
  if (!accountId) return;
  if (provider === "gcp") {
    if (myLocalStorage.getItem("gcpSelectedProjectId") !== accountId) {
      myLocalStorage.setItem("gcpSelectedProjectId", accountId);
      myLocalStorage.setItem("gcpSelectedProjectName", accountId);
    }
  } else if (provider === "azure") {
    if (getAzureSubscription()?.azureSubscriptionId !== accountId) {
      myLocalStorage.setItem(
        "latestSubList",
        JSON.stringify({ azureSubscriptionId: accountId, subscriptionName: accountId }),
      );
    }
  } else if (provider === "aws") {
    if (myLocalStorage.getItem("selectedAwsAccount") !== accountId) {
      myLocalStorage.setItem("selectedAwsAccount", accountId);
      myLocalStorage.setItem("selectedAwsAccountName", accountId);
    }
  }
};
